import { useBreakpointIndex } from '@theme-ui/match-media';
const feedbackWidgetApiCallLimit = {
  feedbackWidgetApiCallLimitOfFeedbacks: 1,
  feedbackWidgetApiCallLimitOfFeedbacksSuggestion: 2
};

const feedbackWidgetQuestionModalTexts = {
  feedbackWidgetQuestionModalRateYourExperience: 'Rate Your Experience'
};

const feedbackWidgetSuggestionScreen = {
  moreFeedbackText: 'Having more feedback will help us'
};
const feedbackWidgetStarRatingColorClasses = [
  'awful',
  'average',
  'good',
  'nocolorOfStar'
];
const feedbackWidgetStarRatingLabels = [
  'Awful',
  'Bad',
  'Average',
  'Good',
  'Excellent'
];

const feedbackWidgetMobileViewIndex = 3;

const feedbackWidgetQuestionModal = () => {
  const index = useBreakpointIndex();
  return {
    overlay: {
      backgroundColor: 'none',
      zIndex: 1002
    },
    content: {
      marginLeft: 'auto',
      marginRight: 'auto',
      inset: index < 3 ? 'auto 0px 0px 0px' : 'auto 20px 10px auto',
      width: index < 3 ? '100%' : '400px',
      background: '#ffffff',
      boxShadow: '0px 12px 24px rgba(0, 0, 0, 0.08)',
      padding: '0px',
      borderRadius: '16px'
    }
  };
};

const feedbackWidgetModalSubmitButtonText = 'Submit';

const feedbackWidgetErrorModalMsg = {
  mandatoryErrorMsg: 'This field is mandatory',
  modalMandtoryErrorMsg: 'Kindly fill all the mandatory fields',
  numericTypeErrorMsg: 'Value must be less than or equal to'
};

const feedbackWidgetSubmitTexts = {
  feedbackWidgetModalSubmitButtonText: 'Submit',
  feedbackWidgetModalSubmitSuccessfullyMsg:
    'Thanks! Feedback submitted successfully'
};

const feedbackWidgetDismissModalButtons = {
  dismissTheFeedbackText: 'Dismiss this feedback!',
  yesSubmitMyRating: 'Yes, submit my rating',
  goBackAndContinue: 'Go back & continue',
  dismissText: 'Dismiss',
  mandatoryFieldsNotFilledText:
    'The star rating would not be saved as all mandatory fields are not filled',
  mandatoryFieldsFilledText: 'Do you want to submit the star rating?'
};

const feedbackRatingZero = 0;

const feedbackWidgetTopicAndFeedbackText = {
  topicText: 'Topic : ',
  feedbackText: 'Feedback | '
};

const feedbackWidgetDismissModal = () => {
  return {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 1003
    },
    content: {
      marginLeft: 'auto',
      marginRight: 'auto',
      inset: '39% 39px 31px auto',
      // inset : "auto",
      boxShadow: '0px 12px 24px rgba(0, 0, 0, 0.08)',
      // padding: ' 24px 0px 0px 0px',
      padding: '0px',
      borderRadius: '5px',
      width: '363px',
      height: 'fit-content',
      backgroundColor: '#FFFFFF',
      overflow: 'hidden',
      border: '#D0000E'
    }
  };
};
const feedbackWidgetErrorModal = () => {
  return {
    overlay: {
      backgroundColor: 'none',
      zIndex: 1004
    },
    content: {
      marginLeft: 'auto',
      marginRight: 'auto',
      inset: 'auto 29px 80px auto',
      background: '#ffffff',
      boxShadow: '0px 12px 24px rgba(0, 0, 0, 0.08)',
      padding: '0px',
      borderRadius: '5px',
      width: '384px',
      backgroundColor: '#FFD6D9',
      overflow: 'hidden',
      padding: '10px 16px',
      border: '1px solid #D0000E'
    }
  };
};
export {
  feedbackWidgetApiCallLimit,
  feedbackWidgetQuestionModalTexts,
  feedbackWidgetQuestionModal,
  feedbackWidgetStarRatingColorClasses,
  feedbackWidgetStarRatingLabels,
  feedbackWidgetErrorModal,
  feedbackWidgetErrorModalMsg,
  feedbackRatingZero,
  feedbackWidgetModalSubmitButtonText,
  feedbackWidgetSubmitTexts,
  feedbackWidgetSuggestionScreen,
  feedbackWidgetDismissModal,
  feedbackWidgetMobileViewIndex,
  feedbackWidgetDismissModalButtons,
  feedbackWidgetTopicAndFeedbackText
};
